import { render, staticRenderFns } from "./peopleManagement.vue?vue&type=template&id=85f73c04&scoped=true"
import script from "./peopleManagement.vue?vue&type=script&lang=js"
export * from "./peopleManagement.vue?vue&type=script&lang=js"
import style0 from "./peopleManagement.vue?vue&type=style&index=0&id=85f73c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f73c04",
  null
  
)

export default component.exports